<div style="cursor: pointer;"
  (click)="onClick()">
  <div [ngClass]="{'pe-none': !isCheckoutValid()}"
    #paypalcheckoutbutton
  [attr.id]="buttonId"></div>
</div>

@if (scriptStatus.error) {
  <div class="col-2 fs-3 left-s"
    >
    {{scriptStatus.error}}
  </div>
}

<status-app-busy-state [status]="paypalSubmitStatus">
  <div class="center">
    <p class="m-b">{{'transaction in progress' | translate}}</p>
    <i class="fs-10 icon-loading"></i>
  </div>
</status-app-busy-state>